import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TablaIcon from '../components/TablaIcon';

const D = {
  bg: '#0e0e0d', surface: '#111110', border: '#2a2927',
  accent: '#c49a3c', text: '#f0ede8', text2: '#a8a49e', text3: '#6b6966',
  input: { background: '#1c1b19', border: '1px solid #2a2927', borderRadius: '8px',
    padding: '10px 14px', color: '#f0ede8', fontSize: '14px', width: '100%',
    fontFamily: "'DM Sans', sans-serif", outline: 'none', boxSizing: 'border-box' },
  btn: { background: '#c49a3c', color: '#0e0e0d', border: 'none', borderRadius: '8px',
    padding: '11px 20px', fontSize: '14px', fontWeight: 600, cursor: 'pointer',
    width: '100%', fontFamily: "'DM Sans', sans-serif" },
};

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [tab,     setTab]     = useState('password'); // 'password' | 'username'
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [msg,     setMsg]     = useState('');
  const [err,     setErr]     = useState('');

  const handle = async () => {
    setErr(''); setMsg('');
    if (!email.trim()) return setErr('Please enter your email address.');
    setLoading(true);
    try {
      const endpoint = tab === 'password' ? '/api/auth/forgot-password' : '/api/auth/forgot-username';
      const r = await axios.post(endpoint, { email: email.trim() });
      setMsg(r.data.message);
    } catch(e) {
      setErr(e.response?.data?.error || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: D.bg, display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px', fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px', cursor: 'pointer' }}
          onClick={() => navigate('/')}>
          <TablaIcon size={40} color={D.accent}/>
          <div style={{ fontSize: '20px', fontWeight: 600, color: D.text, marginTop: '10px' }}>RhythMicky Beats</div>
          <div style={{ fontSize: '12px', color: D.text3, marginTop: '4px' }}>Account Recovery</div>
        </div>

        <div style={{ background: D.surface, border: `1px solid ${D.border}`, borderRadius: '14px', padding: '28px' }}>

          {/* Tabs */}
          <div style={{ display: 'flex', background: '#1c1b19', borderRadius: '8px', padding: '3px', gap: '3px', marginBottom: '24px' }}>
            {[['password','Forgot Password'],['username','Forgot Username']].map(([key, label]) => (
              <button key={key} onClick={() => { setTab(key); setMsg(''); setErr(''); }}
                style={{ flex: 1, padding: '8px', borderRadius: '6px', border: 'none', cursor: 'pointer',
                  fontFamily: D.font, fontSize: '13px', fontWeight: tab===key ? 600 : 400,
                  background: tab===key ? D.accent : 'none',
                  color: tab===key ? '#0e0e0d' : D.text3 }}>
                {label}
              </button>
            ))}
          </div>

          <p style={{ fontSize: '13px', color: D.text2, margin: '0 0 20px', lineHeight: 1.6 }}>
            {tab === 'password'
              ? "Enter your email address and we'll send you a link to reset your password."
              : "Enter your email address and we'll send you your username."}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <input style={D.input} type="email" placeholder="Your email address"
              value={email} onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handle()}/>

            {err && <div style={{ background: '#2a1515', border: '1px solid #5a2020', borderRadius: '8px',
              padding: '10px 14px', fontSize: '13px', color: '#ff6b6b' }}>{err}</div>}
            {msg && <div style={{ background: '#1a2a1a', border: '1px solid #2a5a2a', borderRadius: '8px',
              padding: '10px 14px', fontSize: '13px', color: '#6bff6b' }}>✓ {msg}</div>}

            <button style={D.btn} onClick={handle} disabled={loading}>
              {loading ? 'Sending...' : tab === 'password' ? 'Send Reset Link' : 'Send My Username'}
            </button>

            <button onClick={() => navigate('/login')}
              style={{ background: 'none', border: 'none', color: D.text3, fontSize: '13px',
                cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", padding: '4px' }}>
              ← Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
